(function(){
  if (window.__spStep3CardsInit) return;
  window.__spStep3CardsInit = true;

  var SHAPES = ['Elongated Hexagon','Antique Cushion','Long Cushion','Old European','Old Mine',
    'Dutch Marquise','French Marquise','Portuguese','Hexagon','Asscher','Princess',
    'Marquise','Cushion','Emerald','Radiant','Round','Oval','Pear','Heart','Moval'];
  var CLARITIES = ['FL','IF','VVS1','VVS2','VS1','VS2','SI1','SI2','I1','I2','I3'];

  function txt(el){ return el ? (el.textContent||'').replace(/\s+/g,' ').trim() : ''; }

  function priceParts(node){
    if (!node) return { price:'', compare:'' };
    var compareEl = node.querySelector('.price__regular');
    var compare = compareEl ? txt(compareEl) : '';
    var clone = node.cloneNode(true);
    clone.querySelectorAll('.price__regular').forEach(function(c){ c.remove(); });
    var price = txt(clone);
    return { price:price, compare:compare };
  }
  function moneyToNumber(s){
    if (!s) return null;
    var n = parseFloat(s.replace(/[^0-9.]/g,''));
    return isNaN(n) ? null : n;
  }
  function pctOff(price, compare){
    var p = moneyToNumber(price), c = moneyToNumber(compare);
    if (!p || !c || c <= p) return 0;
    return Math.round((c - p) / c * 100);
  }
  function getSettingTitle(){
    var t = document.querySelector('#finalmainsection .product-single__title');
    if (!t) return '';
    var clone = t.cloneNode(true);
    var pair = clone.querySelector('.sp-stp-pair');
    if (pair) pair.remove();
    return txt(clone);
  }
  function getMetalName(){
    var m = document.querySelector('#finalmainsection .metal__info');
    if (!m) return '';
    return txt(m).split('/')[0].trim();
  }
  function readDiamond(){
    var section = document.getElementById('finalmainsection');
    if (!section) return { shape:'', short:'' };
    var info    = txt(section.querySelector('.diamond__info'));
    var shape   = txt(section.querySelector('.shape-info'));
    var carat   = txt(section.querySelector('.carat-info'));
    var color   = txt(section.querySelector('#color-info')   || section.querySelector('.color-info'));
    var clarity = txt(section.querySelector('#clarity-info') || section.querySelector('.clarity-info'));
    if (info && !shape){
      for (var i=0;i<SHAPES.length;i++){
        if (new RegExp('\\b'+SHAPES[i].replace(/\s+/g,'\\s+')+'\\b','i').test(info)){
          shape = SHAPES[i]; break;
        }
      }
    }
    if (info && !carat){
      var m = info.match(/(\d+(?:\.\d+)?)\s*(?:ct|carat)/i);
      if (m) carat = m[1];
    }
    if (info && !color){
      var c = info.match(/\b([D-K])\b/);
      if (c) color = c[1];
    }
    if (info && !clarity){
      for (var j=0;j<CLARITIES.length;j++){
        if (new RegExp('\\b'+CLARITIES[j]+'\\b').test(info)){ clarity = CLARITIES[j]; break; }
      }
    }
    carat = (carat||'').replace(/\s*(ct|carat)\s*/i,'').trim();
    var parts = [];
    if (carat) parts.push(carat + 'ct');
    if (color) parts.push(color.toUpperCase());
    if (clarity) parts.push(clarity.toUpperCase());
    return { shape:shape, short:parts.join(' ') };
  }

  function buildCards(section){
    if (section.querySelector('.sp-stp-cards')) return section.querySelector('.sp-stp-cards');
    var anchor = section.querySelector('.product-single__metal-diamond');
    if (!anchor) return null;

    var wrap = document.createElement('div');
    wrap.className = 'sp-stp-cards';
    wrap.innerHTML =
      '<div class="sp-stp-card" data-card="setting">' +
        '<div class="sp-stp-card__body">' +
          '<span class="sp-stp-card__title" data-bind="setting-name">—</span>' +
          '<span class="sp-stp-card__sub"   data-bind="setting-metal">—</span>' +
          '<div class="sp-stp-card__actions">' +
            '<a href="#" data-action="setting-change">Change</a>' +
            '<span>|</span>' +
            '<a href="#" data-action="setting-details">View Details</a>' +
          '</div>' +
        '</div>' +
        '<div class="sp-stp-card__price-block">' +
          '<span class="sp-stp-card__price"   data-bind="setting-price">—</span>' +
          '<div class="sp-stp-card__compare-row">' +
            '<span class="sp-stp-card__compare" data-bind="setting-compare"></span>' +
            '<span class="sp-stp-card__badge"   data-bind="setting-badge" hidden></span>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="sp-stp-card" data-card="stone">' +
        '<div class="sp-stp-card__body">' +
          '<span class="sp-stp-card__title" data-bind="stone-shape">—</span>' +
          '<span class="sp-stp-card__sub"   data-bind="stone-spec">—</span>' +
          '<div class="sp-stp-card__actions">' +
            '<a href="#" data-action="stone-change">Change</a>' +
            '<span>|</span>' +
            '<a href="#" data-action="stone-details">View Details</a>' +
          '</div>' +
        '</div>' +
        '<div class="sp-stp-card__price-block">' +
          '<span class="sp-stp-card__price"   data-bind="stone-price">—</span>' +
          '<div class="sp-stp-card__compare-row">' +
            '<span class="sp-stp-card__compare" data-bind="stone-compare"></span>' +
            '<span class="sp-stp-card__badge"   data-bind="stone-badge" hidden></span>' +
          '</div>' +
        '</div>' +
      '</div>';

    /* 2026-07-28: the breakdown belongs BELOW the Add to Cart form (Blue Nile
       order). It used to be inserted directly after the title and then pushed
       down the column visually by `order: 8` in spx-step3-bn.css. Creating it
       in its final position instead is what lets that order ladder go away.

       Note this is an insert-on-create, never a move: buildCards() returns
       early if .sp-stp-cards already exists, so a re-render can't drag it
       back up the column. */
    var meta = section.querySelector('.product-single__meta');
    var form = meta && (meta.querySelector(':scope > form[action*="/cart/add"]')
                     || meta.querySelector(':scope > form'));
    if (form){
      form.parentNode.insertBefore(wrap, form.nextSibling);
    } else {
      /* Pre-2026-07-28 placement. Only reached if the cart form is missing,
         in which case the page is broken anyway and position is moot. */
      var title = section.querySelector('.product-single__title');
      if (title && title.parentNode){
        title.parentNode.insertBefore(wrap, title.nextSibling);
      } else {
        anchor.parentNode.insertBefore(wrap, anchor);
      }
    }
    wireActions(wrap);
    return wrap;
  }

  /* Find the first known-good aligned element below the title block.
     These are body elements that the user has confirmed are aligned. */
  function findAlignmentReference(section){
    var candidates = [
      '.product-engraving-wrapper',
      '.product_description--accordion',
      '.sp-rsd-row',
      '#productprice',
      '.product-form'
    ];
    for (var i=0; i<candidates.length; i++){
      var el = section.querySelector(candidates[i]);
      if (el){
        var r = el.getBoundingClientRect();
        if (r.width > 50) return el;  // skip if not laid out yet
      }
    }
    return null;
  }

  /* Force the eyebrow + title + cards to share the SAME left/right
     bounds as a known-good reference element below them. Margin diff
     is computed off bounding rects. */
  function alignHeaderToReference(section){
    var ref = findAlignmentReference(section);
    if (!ref) return false;
    var refRect = ref.getBoundingClientRect();

    var targets = [
      section.querySelector('#collectionTitle'),
      section.querySelector('.product-single__collection'),
      section.querySelector('.product-single__title'),
      section.querySelector('.sp-stp-cards')
    ].filter(Boolean);

    targets.forEach(function(el){
      el.style.marginLeft = '';
      el.style.marginRight = '';
      el.style.boxSizing = 'border-box';
      var elRect = el.getBoundingClientRect();
      var leftDiff = refRect.left - elRect.left;
      var rightDiff = elRect.right - refRect.right;
      if (Math.abs(leftDiff) >= 1) el.style.marginLeft = leftDiff + 'px';
      if (Math.abs(rightDiff) >= 1) el.style.marginRight = rightDiff + 'px';
    });
    return true;
  }

  function wireActions(wrap){
    wrap.querySelectorAll('[data-action="setting-change"]').forEach(function(a){
      a.addEventListener('click', function(e){
        e.preventDefault();
        var section = document.getElementById('finalmainsection');
        if (section) section.style.display = 'none';
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
    wrap.querySelectorAll('[data-action="stone-change"]').forEach(function(a){
      a.addEventListener('click', function(e){
        e.preventDefault();
        window.location.href = '/pages/diamonds';
      });
    });
    function scrollToAccordion(matchPattern){
      var headers = document.querySelectorAll('#finalmainsection .accordion-header');
      for (var i=0;i<headers.length;i++){
        if (matchPattern.test(headers[i].textContent || '')){
          headers[i].scrollIntoView({ behavior:'smooth', block:'center' });
          if (!headers[i].classList.contains('active')) headers[i].click();
          return;
        }
      }
    }
    wrap.querySelectorAll('[data-action="setting-details"]').forEach(function(a){
      a.addEventListener('click', function(e){
        e.preventDefault();
        scrollToAccordion(/ring|setting/i);
      });
    });
    wrap.querySelectorAll('[data-action="stone-details"]').forEach(function(a){
      a.addEventListener('click', function(e){
        e.preventDefault();
        scrollToAccordion(/diamond/i);
      });
    });
  }

  function setBind(wrap, key, val){
    var node = wrap.querySelector('[data-bind="'+key+'"]');
    if (!node) return;
    var current = node.textContent || '';
    var next = val || '';
    if (current !== next) node.textContent = next;
  }
  function setBadge(wrap, key, pct){
    var node = wrap.querySelector('[data-bind="'+key+'"]');
    if (!node) return;
    if (pct > 0){
      var nextText = pct + '% off';
      if (node.textContent !== nextText) node.textContent = nextText;
      if (node.hasAttribute('hidden')) node.removeAttribute('hidden');
    } else {
      if (!node.hasAttribute('hidden')) node.setAttribute('hidden','');
    }
  }
  function syncCards(wrap){
    var section = document.getElementById('finalmainsection');
    if (!section || !wrap) return;
    var settingP = priceParts(section.querySelector('.product-single__setting-price'));
    var stoneP   = priceParts(section.querySelector('.product-single__diamond-price'));
    setBind(wrap, 'setting-name',    getSettingTitle());
    setBind(wrap, 'setting-metal',   getMetalName());
    setBind(wrap, 'setting-price',   settingP.price);
    setBind(wrap, 'setting-compare', settingP.compare);
    setBadge(wrap, 'setting-badge', pctOff(settingP.price, settingP.compare));
    var d = readDiamond();
    setBind(wrap, 'stone-shape', d.shape || '—');
    setBind(wrap, 'stone-spec',  d.short);
    setBind(wrap, 'stone-price', stoneP.price);
    setBind(wrap, 'stone-compare', stoneP.compare);
    setBadge(wrap, 'stone-badge', pctOff(stoneP.price, stoneP.compare));
  }
  function startSourceObserver(wrap){
    if (wrap.__spSrcObs) return;
    var section = document.getElementById('finalmainsection');
    if (!section) return;
    var sources = [
      section.querySelector('.product-single__title'),
      section.querySelector('.metal__info'),
      section.querySelector('.diamond__info'),
      section.querySelector('.product-single__setting-price'),
      section.querySelector('.product-single__diamond-price'),
      section.querySelector('.shape-info'),
      section.querySelector('.carat-info'),
      section.querySelector('#color-info'),
      section.querySelector('#clarity-info')
    ].filter(Boolean);
    if (!sources.length) return;
    var pending = false;
    var obs = new MutationObserver(function(){
      if (pending) return;
      pending = true;
      requestAnimationFrame(function(){ pending = false; syncCards(wrap); });
    });
    sources.forEach(function(n){
      obs.observe(n, { childList:true, subtree:true, characterData:true });
    });
    wrap.__spSrcObs = obs;
  }

  function tryInit(){
    var section = document.getElementById('finalmainsection');
    if (!section) return false;
    if (!section.querySelector('.product-single__metal-diamond')) return false;
    var wrap = buildCards(section);
    if (!wrap) return false;
    syncCards(wrap);
    startSourceObserver(wrap);

    /* Run alignment after layout settles. Re-run on resize. */
    var doAlign = function(){
      var s = document.getElementById('finalmainsection');
      if (s) alignHeaderToReference(s);
    };
    requestAnimationFrame(doAlign);
    setTimeout(doAlign, 400);
    setTimeout(doAlign, 1200);
    setTimeout(doAlign, 2500);
    if (!window.__spStep3CardsResize){
      window.__spStep3CardsResize = true;
      window.addEventListener('resize', doAlign);
    }
    return true;
  }

  function bootstrap(){
    if (tryInit()) return;
    var attempts = 0;
    var iv = setInterval(function(){
      attempts++;
      if (tryInit() || attempts > 30){ clearInterval(iv); }
    }, 250);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
